// extracted by mini-css-extract-plugin
module.exports =  {"week":"_2787e5dfdf--week--AmWim"};